<template lang="pug">

.finish-time
  .underlay
    span 00
    span.colon :
    span 00
  .overlay
    span
      animated-number(
        v-bind:time="800"
        v-bind:pad="2"
        v-bind:number="min"
        v-show="min"
      )
    span.colon :
    span
      animated-number(
        v-bind:time="800"
        v-bind:pad="2"
        v-bind:number="sec"
      )

</template>

<script>
import AnimatedNumber from 'src/components/animated-number/AnimatedNumber'

export default {
  name: 'share',
  components: {
    AnimatedNumber
  },
  props: [
    'time'
  ],
  data () {
    return {

    }
  },
  computed: {
    min () {
      return Math.floor(this.time / 1000 / 60)
    },
    sec () {
      return Math.floor((this.time / 1000) % 60)
    }
  },
  mounted: function() {

  },
  beforeDestroy: function() {

  },
  methods: {

  }
}
</script>

<style lang="sass" scoped>
@import "src/common.sass"


.finish-time
  position: relative
  font-size: 90px
  font-family: "digital"
  margin-bottom: 0
  overflow: visible
  font-style: normal
  height: 82px
  width: 192px

  .underlay
    // opacity: 0.2
    color: rgba(0, 0, 0, 0.15)

  .overlay
    position: absolute
    top: 0
    right: 0

  .colon
    display: inline-block
    // transform: translateY(-16%)
    margin: 0 -0.07em

// @media (min-width: 600px)
//   .finish-time
//     font-size: 50px
//     width: 108px

</style>



// WEBPACK FOOTER //
// FinishTime.vue?1f9d43e5